import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {TreatmentChain} from '../../../../../model/treatment-chain';
import {TreatmentChainService} from '../../../../../services/apiServices/business/treatment-chain.service';
import {UserManagementService} from '../../../../../services/apiServices/business/user-management.service';
import {TranslateService} from '@ngx-translate/core';
import {CommonService} from '../../../../../services/apiServices/business/common.service';

@Component({
  selector: 'app-group-chains',
  templateUrl: './group-chains.component.html',
  styleUrls: ['./group-chains.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GroupChainsComponent implements OnInit {
  @Output() configSaved: EventEmitter<boolean>;
  @Input() groupId: string;
  errorTitle: string;
  availableList: TreatmentChain[];
  selectedList: TreatmentChain[];


  constructor(private treatmentChainService: TreatmentChainService,
              private translate: TranslateService,
              private userManagementService: UserManagementService,
              private commonService: CommonService) {
    this.configSaved = new EventEmitter<boolean>();
  }

  ngOnInit() {
    this.translate.get('TOASTER.ERROR_MESSAGE_TITLE').subscribe((res: string) => {
      this.errorTitle = res;
    });
    const tempAvailableList = [];
    const tempSelectedList = [];

    this.userManagementService.getGroupChain(this.groupId).subscribe(response => {
      const groupChains = response || [];
      for (const chain of this.treatmentChainService.getTreatmentChainList()) {
        let found = false;
        for (const selected of groupChains) {
          if (chain.sTrtChainName === selected) {
            found = true;
            break;
          }
        }
        if (!found) {
          tempAvailableList.push(chain);
        }
      }
      for (const selected of groupChains) {
        for (const chain of this.treatmentChainService.getTreatmentChainList()) {
          if (selected === chain.sTrtChainName) {
            tempSelectedList.push(chain);
            break;
          }
        }
      }
      this.availableList = tempAvailableList;
      this.selectedList = tempSelectedList;
    });
  }

  saveConfig() {
    const listChains = [];
    for (const chain of this.selectedList) {
      listChains.push(chain.sTrtChainName);
    }
    const dataToSend = new FormData();
    dataToSend.append('groupId', this.groupId);
    dataToSend.append('chains', JSON.stringify(listChains));
    this.userManagementService.saveGroupChain(dataToSend).subscribe((response: any) => {
      if (response.bOK) {
        this.configSaved.emit(true);
      } else {
        if (response.sMsgError) {
          this.commonService.addToast({
            life: 5000,
            severity: 'error',
            summary: this.errorTitle,
            detail: response.sMsgError
          });
        }
      }
    });
  }
}
